import React from 'react';
import { StyledCardWrapper } from './AccountCard.styles';
import { Card } from '@sections/registry/components';
import { themeColor } from '@utils/styledTheme.util';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

export const AccountCard = () => {
  const theme = useTheme();
  const { t } = useTranslation('registry');
  const accountCard = t('guestExperienceSection.accountCard');
  return (
    <StyledCardWrapper>
      <Card
        eyebrow={accountCard.eyebrow}
        eyebrowVariant="featureHed17"
        eyebrowColor="humanaDark4"
        title={accountCard.title}
        titleVariant="calloutHed32"
        titleColor="mono1"
        wrapperStyles={{
          backgroundColor: themeColor('humana1')({ theme }),
        }}
      />
    </StyledCardWrapper>
  );
};
